import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=c5326242&scoped=true"
import script from "./qrcode.vue?vue&type=script&lang=js"
export * from "./qrcode.vue?vue&type=script&lang=js"
import style0 from "./qrcode.vue?vue&type=style&index=0&id=c5326242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5326242",
  null
  
)

export default component.exports